import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditDeleteButtonGroupComponent } from './edit-delete-button-group/edit-delete-button-group.component';
import { DeleteDialogComponent } from './dialog/delete-dialog/delete-dialog.component';
import {
  BuildingSectionDeleteDialogComponent,
} from './dialog/building-section-delete-dialog/building-section-delete-dialog.component';
import {
  CorporateGroupDeleteDialogComponent,
} from './dialog/corporate-group-delete-dialog/corporate-group-delete-dialog.component';
import {
  SensorBlockDeleteDialogComponent,
} from './dialog/sensor-block-delete-dialog/sensor-block-delete-dialog.component';
import { OrderToggleButtonComponent } from './order-toggle-button/order-toggle-button.component';
import { PaginationButtonGroupComponent } from './pagination-button-group/pagination-button-group.component';
import { PageSizeSelectorComponent } from './page-size-selector/page-size-selector.component';
import { CheckpointDialogComponent } from './dialog/checkpoint-dialog/checkpoint-dialog.component';
import { ConfirmDialogComponent } from './dialog/confirm-dialog/confirm-dialog.component';
import {
  TemplateSelectionDialogComponent,
} from './dialog/template-selection-dialog/template-selection-dialog.component';
import {
  PreviousInspectionDialogComponent,
} from './dialog/previous-inspection-dialog/previous-inspection-dialog.component';
import { StatusTextComponent } from './status-text/status-text.component';
import { SharedModule } from '@shared/shared.module';
import { PageScrollFabComponent } from './page-scroll-fab/page-scroll-fab.component';
import { ConfirmEditDialogComponent } from './dialog/confirm-edit-dialog/confirm-edit-dialog.component';
import {
  ApplyFromOtherSectionDialogComponent,
} from './dialog/apply-from-other-section-dialog/apply-from-other-section-dialog.component';
import { BaseDialogComponent } from './dialog/base-dialog/base-dialog.component';
import { DuplicateSectionDialogComponent } from './dialog/duplicate-section-dialog/duplicate-section-dialog.component';
import { GroupedCheckboxListComponent } from './grouped-checkbox-list/grouped-checkbox-list.component';
import { BuildingSectionSelectComponent } from './building-section-select/building-section-select.component';
import { AttachmentDialogComponent } from './dialog/attachment-dialog/attachment-dialog.component';
import { SubFolderDialogComponent } from './dialog/sub-folder-dialog/sub-folder-dialog.component';
import { SplitViewComponent } from './split-view/split-view.component';
import { ListDetailSplitViewComponent } from './split-view/list-detail-split-view/list-detail-split-view.component';
import { DetailViewDirective } from './split-view/list-detail-split-view/detail-view.directive';
import { FormElementWrapperComponent } from './form-element-wrapper/form-element-wrapper.component';
import { CheckpointWeightComponent } from './checkpoint-weight/checkpoint-weight.component';
import { BuildingConditionComponent } from './building-condition/building-condition.component';
import { HauFormsModule } from '@sonofabit/ng-core';
import { FormActionsComponent } from './form-actions/form-actions.component';
import { RepairTasksComponent } from '@pages/inspection-detail-page-v2/repair-tasks/repair-tasks.component';
import {
  RepairTaskItemComponent
} from '@pages/inspection-detail-page-v2/repair-tasks/repair-task-item/repair-task-item.component';
import { RepairTaskStatusIconComponent } from './repair-task-status-icon/repair-task-status-icon.component';
import { RepairTaskEditDialogComponent } from './dialog/repair-task-edit-dialog/repair-task-edit-dialog.component';
import {
  RepairTaskGenerateComponent
} from '@pages/inspection-detail-page-v2/repair-tasks/repair-task-generate/repair-task-generate.component';
import { RepairTaskStatusTextComponent } from './repair-task-status-text/repair-task-status-text.component';
import { ListViewComponent } from '@shared/components/list-view/list-view.component';
import { SendEmailComponent } from './dialog/send-email/send-email.component';
import { RepairTaskCreateDialogComponent } from './dialog/repair-task-create-dialog/repair-task-create-dialog.component';
import {
  RepairTaskContractorHintComponent,
} from './repair-task-contractor-hint/repair-task-contractor-hint.component';
import { PageComponent } from './page/page.component';
import { RouterLink } from '@angular/router';
import { TableComponent } from './table/table.component';
import { ColumnDirective } from '@components/table/column.directive';
import { PaginationDirective } from '@components/table/pagination.directive';
import { CoordinateDialogComponent } from './dialog/coordinate-dialog/coordinate-dialog.component';
import { AddressDialogComponent } from '@components/dialog/address-dialog/address-dialog.component';
import { PropertyManagerDialogComponent } from './dialog/property-manager-dialog/property-manager-dialog.component';
import { ContactPersonDialogComponent } from './dialog/contact-person-dialog/contact-person-dialog.component';
import { ShareLinkDialogComponent } from './dialog/share-link-dialog/share-link-dialog.component';
import { InfoDialogComponent } from './dialog/info-dialog/info-dialog.component';
import { InspectionGuidelinesWindowComponent } from './dialog/inspection-guidelines-window/inspection-guidelines-window.component';
import { BuildingScanListComponent } from './building-scan-list/building-scan-list.component';
import {
  BuildingScanPendingRowComponent
} from '@components/building-scan-list/building-scan-pending-row/building-scan-pending-row.component';
import {
  BuildingScanCardComponent
} from '@components/building-scan-list/building-scan-card/building-scan-card.component';
import { FullScreenPanelComponent } from './full-screen-panel/full-screen-panel.component';
import {
  FullScreenButtonComponent
} from '@components/full-screen-panel/full-screen-button/full-screen-button.component';
import { PdfShareLinkDialogComponent } from '@components/dialog/pdf-share-link-dialog/pdf-share-link-dialog.component';
import { ProtocolPublishDialogComponent } from '@components/dialog/protocol-publish-dialog/protocol-publish-dialog.component';
import { ProtocolShareLinkDialogComponent } from '@components/dialog/protocol-share-link-dialog/protocol-share-link-dialog.component';
import { ClipboardButtonComponent } from './clipboard-button/clipboard-button.component';
import {
  PrivilegeHierarchyControlComponent
} from './privilege-hierarchy-control/privilege-hierarchy-control.component';
import { CdkTreeModule } from '@angular/cdk/tree';
import { PrivilegeIconComponent } from './privilege-icon/privilege-icon.component';
import { NotificationsModule } from '@/notifications/notifications.module';
import { GenericDialogComponent } from '@components/dialog/generic-dialog/generic-dialog.component';
import { BuildingSectionEditorComponent } from '@components/building-section-editor/building-section-editor.component';
import { ExportFormatDialogComponent } from '@components/dialog/export-format-dialog/export-format-dialog.component';
import {
  FinishMaintenanceTimerDialogComponent
} from '@components/dialog/finish-maintenance-timer-dialog/finish-maintenance-timer-dialog.component';
import { RepairTaskCloseDialogComponent } from '@components/dialog/repair-task-close-dialog/repair-task-close-dialog.component';
import { YearOverYearGaugeComponent } from '@components/year-over-year-gauge/year-over-year-gauge.component';
import { PlotlyComponent } from 'angular-plotly.js';
import {
  YearlyLabelSummaryChartComponent
} from '@components/yearly-label-summary-chart/yearly-label-summary-chart.component';
import {
  BuildingDashboardSelectComponent
} from '@components/building-dashboard-select/building-dashboard-select.component';
import { ControlSystemDialogComponent } from '@components/dialog/control-system-dialog/control-system-dialog.component';
import { SensorBlockItemComponent } from '@components/sensor-block-item/sensor-block-item.component';
import { SensorItemComponent } from '@components/sensor-item/sensor-item.component';
import { SensorBlockListComponent } from '@components/sensor-block-list/sensor-block-list.component';
import { MoreMenuComponent } from '@components/more-menu/more-menu.component';
import { CustomConfirmDialogComponent } from '@components/dialog/custom-confirm-dialog/custom-confirm-dialog.component';
import {
  TextBlockSelectDialogComponent
} from '@components/dialog/text-block-select-dialog/text-block-select-dialog.component';
import {
  YearlyUnitSummaryChartComponent
} from '@components/yearly-unit-summary-chart/yearly-unit-summary-chart.component';
import {
  BuildingCoordinatesDialogComponent
} from '@components/dialog/building-coordinates-dialog/building-coordinates-dialog.component';
import { SelectRecipientComponent } from '@components/select-recipient/select-recipient.component';
import { BuildingScanDialogComponent } from '@components/dialog/building-scan-dialog/building-scan-dialog.component';
import { ScanSectionSelectDialogComponent } from '@components/dialog/scan-section-select-dialog/scan-section-select-dialog.component';
import { LightboxModule } from 'ngx-lightbox';
import {
  ApplicationStatusBadgeComponent
} from '@components/application-status-badge/application-status-badge.component';
import {
  BuildingApplicationApproveDialogComponent
} from '@components/dialog/building-application-approve-dialog/building-application-approve-dialog.component';
import {
  BuildingApplicationRejectDialogComponent
} from '@components/dialog/building-application-reject-dialog/building-application-reject-dialog.component';
import {
  ProfiNeoSyncDialogComponent
} from '@components/dialog/profi-neo-sync-dialog/profi-neo-sync-dialog.component';
import {
  ChangeUserPasswordDialogComponent
} from '@components/dialog/change-user-password-dialog/change-user-password-dialog.component';
import {
  GeneratedPasswordDialogComponent
} from '@components/dialog/generated-password-dialog/generated-password-dialog.component';
import {
  ReassignSectionDialogComponent
} from '@components/dialog/reassign-section-dialog/reassign-section-dialog.component';
import {
  ContractorAttachmentFolderViewComponent
} from '@components/contractor-attachment-folder-view/contractor-attachment-folder-view.component';
import {
  ProtocolCreateDialogComponent
} from '@components/dialog/protocol-create-dialog/protocol-create-dialog.component';

@NgModule({
  declarations: [
    EditDeleteButtonGroupComponent,
    DeleteDialogComponent,
    BuildingSectionDeleteDialogComponent,
    CorporateGroupDeleteDialogComponent,
    SensorBlockDeleteDialogComponent,
    OrderToggleButtonComponent,
    PaginationButtonGroupComponent,
    PageSizeSelectorComponent,
    CheckpointDialogComponent,
    ConfirmDialogComponent,
    TemplateSelectionDialogComponent,
    PreviousInspectionDialogComponent,
    StatusTextComponent,
    PageScrollFabComponent,
    ConfirmEditDialogComponent,
    ApplyFromOtherSectionDialogComponent,
    BaseDialogComponent,
    DuplicateSectionDialogComponent,
    ExportFormatDialogComponent,
    GroupedCheckboxListComponent,
    BuildingSectionSelectComponent,
    CheckpointWeightComponent,
    BuildingConditionComponent,
    AttachmentDialogComponent,
    SubFolderDialogComponent,
    SplitViewComponent,
    ListDetailSplitViewComponent,
    DetailViewDirective,
    FormElementWrapperComponent,
    FormActionsComponent,
    RepairTasksComponent,
    RepairTaskItemComponent,
    RepairTaskStatusIconComponent,
    RepairTaskEditDialogComponent,
    RepairTaskGenerateComponent,
    RepairTaskStatusTextComponent,
    SendEmailComponent,
    RepairTaskCreateDialogComponent,
    RepairTaskContractorHintComponent,
    PageComponent,
    TableComponent,
    ColumnDirective,
    PaginationDirective,
    CoordinateDialogComponent,
    AddressDialogComponent,
    ShareLinkDialogComponent,
    PdfShareLinkDialogComponent,
    ProtocolPublishDialogComponent,
    ProtocolShareLinkDialogComponent,
    AddressDialogComponent,
    PropertyManagerDialogComponent,
    ContactPersonDialogComponent,
    InfoDialogComponent,
    InspectionGuidelinesWindowComponent,
    BuildingScanListComponent,
    BuildingScanPendingRowComponent,
    BuildingScanCardComponent,
    FullScreenPanelComponent,
    FullScreenButtonComponent,
    ClipboardButtonComponent,
    PrivilegeHierarchyControlComponent,
    PrivilegeIconComponent,
    GenericDialogComponent,
    BuildingSectionEditorComponent,
    YearOverYearGaugeComponent,
    YearlyLabelSummaryChartComponent,
    BuildingDashboardSelectComponent,
    ControlSystemDialogComponent,
    SensorBlockItemComponent,
    SensorItemComponent,
    SensorBlockListComponent,
    MoreMenuComponent,
    CustomConfirmDialogComponent,
    TextBlockSelectDialogComponent,
    YearlyUnitSummaryChartComponent,
    BuildingCoordinatesDialogComponent,
    FinishMaintenanceTimerDialogComponent,
    RepairTaskCloseDialogComponent,
    SelectRecipientComponent,
    BuildingScanDialogComponent,
    ScanSectionSelectDialogComponent,
    ApplicationStatusBadgeComponent,
    BuildingApplicationApproveDialogComponent,
    BuildingApplicationRejectDialogComponent,
    ProfiNeoSyncDialogComponent,
    ContractorAttachmentFolderViewComponent,
    ProtocolCreateDialogComponent,
    ChangeUserPasswordDialogComponent,
    ReassignSectionDialogComponent,
    GeneratedPasswordDialogComponent,
  ],
  exports: [
    EditDeleteButtonGroupComponent,
    OrderToggleButtonComponent,
    PaginationButtonGroupComponent,
    PageSizeSelectorComponent,
    StatusTextComponent,
    PageScrollFabComponent,
    BuildingSectionSelectComponent,
    CheckpointWeightComponent,
    BuildingConditionComponent,
    SplitViewComponent,
    ListDetailSplitViewComponent,
    DetailViewDirective,
    FormElementWrapperComponent,
    BaseDialogComponent,
    RepairTasksComponent,
    FormActionsComponent,
    ListViewComponent,
    RepairTaskItemComponent,
    TableComponent,
    ColumnDirective,
    PaginationDirective,
    RepairTaskStatusTextComponent,
    PageComponent,
    AddressDialogComponent,
    RepairTaskStatusIconComponent,
    BuildingScanListComponent,
    FullScreenPanelComponent,
    FullScreenButtonComponent,
    PrivilegeHierarchyControlComponent,
    GenericDialogComponent,
    BuildingSectionEditorComponent,
    YearOverYearGaugeComponent,
    YearlyLabelSummaryChartComponent,
    BuildingDashboardSelectComponent,
    ControlSystemDialogComponent,
    SensorBlockItemComponent,
    SensorItemComponent,
    SensorBlockListComponent,
    MoreMenuComponent,
    CustomConfirmDialogComponent,
    TextBlockSelectDialogComponent,
    YearlyUnitSummaryChartComponent,
    BuildingSectionEditorComponent,
    FinishMaintenanceTimerDialogComponent,
    RepairTaskCloseDialogComponent,
    SelectRecipientComponent,
    BuildingScanDialogComponent,
    ScanSectionSelectDialogComponent,
    ApplicationStatusBadgeComponent,
    InspectionGuidelinesWindowComponent,
    ContractorAttachmentFolderViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    HauFormsModule,
    RouterLink,
    CdkTreeModule,
    CdkScrollableModule,
    NotificationsModule,
    PlotlyComponent,
    LightboxModule,
  ],
})
export class ComponentsModule {
}
